module.exports = {
  head: {
    title: 'Modern Slavery Statement | Fresh Recipe Boxes | Gousto',
    meta: [
      {
        name: 'description',
        content: 'Gousto\'s Modern Slavery Statement can be found on the website. Read the full statement today.',
      },
      {
        name: 'keywords',
        content: 'Gousto, recipe delivery, ingredients, fresh, healthy food, cooking',
      },
    ],
  },
}
